
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';

var script = {
  name: 'PendoEmptyState',
  components: {
    PendoIcon
  },
  props: {
    icon: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: '#FFF'
    }
  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-empty-state",
    style: {
      'background-color': _vm.backgroundColor
    }
  }, [_c('div', {
    staticClass: "pendo-empty-state__inner"
  }, [_vm.icon || !!_vm.$slots.icon ? _c('div', {
    staticClass: "pendo-empty-state__icon"
  }, [_vm._t("icon", [_vm.icon ? _c('pendo-icon', _vm._b({}, 'pendo-icon', _vm.icon, false)) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _vm.title || !!_vm.$slots.title ? _c('div', {
    staticClass: "pendo-empty-state__title"
  }, [_vm._t("title", [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])], 2) : _vm._e(), _vm._v(" "), _vm.description || !!_vm.$slots.description ? _c('div', {
    staticClass: "pendo-empty-state__description"
  }, [_vm._t("description", [_vm._v("\n                " + _vm._s(_vm.description) + "\n            ")])], 2) : _vm._e(), _vm._v(" "), !!_vm.$slots.actions ? _vm._t("actions") : _vm._e()], 2)]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-empty-state.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoEmptyState = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoEmptyState;
